import { EmailNotification } from "types/interface.types";
import { authApi } from "./";

export const send = async (payload: EmailNotification) => {
  const response = await authApi.post("email/send", payload);
  return response;
};
